import { useMutation } from "@apollo/client";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { UPDATE_CUSTOMER_TASK } from "../customer-task.queries";
import { parseParams } from "../../../helpers/clean-object";

import { UpdateCustomerTaskInput } from "../../../__generated__/globalTypes";
import {
  UpdateCustomerTaskMutation,
  UpdateCustomerTaskMutationVariables,
} from "../../../__generated__/UpdateCustomerTaskMutation";

interface IProps {
  id: number;
  onCompleted: () => any;
}

export const useUpdateCustomerTask = ({ id, onCompleted }: IProps) => {
  const form = useForm<UpdateCustomerTaskInput>({
    mode: "all",
  });
  const [mutate, { loading }] = useMutation<
    UpdateCustomerTaskMutation,
    UpdateCustomerTaskMutationVariables
  >(UPDATE_CUSTOMER_TASK, {
    refetchQueries: ["CustomerTasksQuery", "CustomerTaskQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          id,
          input: parseParams(input),
        },
      });

      if (data?.updateCustomerTask?.ok) {
        onCompleted();
      } else {
        throw Error(data?.updateCustomerTask?.error ?? "Error");
      }
    } catch (error: any) {
      toast.error(error?.message ?? "Une erreur est survenue");
    }
  };

  return {
    form,
    mutate,
    loading,
    submit,
  };
};
